import React from 'react';
import styled from 'styled-components';

import { ReactComponent as LogoSvg } from '../../../lib/image/icons/logo/logo.svg';

export const Logo = ({ white = undefined, ...props }) => {
  return <StyleSVG white={white} {...props} />;
};

const StyleSVG = styled(LogoSvg)`
  fill:${(props) => (props.white ? 'white' : props.theme.color.orangePink)}
  width: 6.25rem;
  height: auto;
    margin-top: 0.2rem;
`;
